import { render, staticRenderFns } from "./Uber3.vue?vue&type=template&id=6e8920eb&scoped=true&"
import script from "./Uber3.vue?vue&type=script&lang=js&"
export * from "./Uber3.vue?vue&type=script&lang=js&"
import style0 from "./Uber3.vue?vue&type=style&index=0&id=6e8920eb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8920eb",
  null
  
)

export default component.exports